import { motion, useScroll, useTransform } from "framer-motion";

export default function BlobTry() {
  const { scrollYProgress } = useScroll();

  // Map scroll progress (0 → 1) to motion values
  const x = useTransform(scrollYProgress, [0, 1], ["-15vw", "20vw"]);
  const y = useTransform(scrollYProgress, [0, 1], ["-10vh", "30vh"]);
  const rotate = useTransform(scrollYProgress, [0, 1], [0, 360]);
  const scale = useTransform(scrollYProgress, [0, 1], [0.9, 1.15]);

  // Second blob: 25% bigger, moving within the current viewport
  // Start: around center‑right, a bit higher
  // Finish: slightly left of center, closer to the top
  const x2 = useTransform(scrollYProgress, [0, 1], ["5vw", "-5vw"]);
  const y2 = useTransform(scrollYProgress, [0, 1], ["40vh", "0vh"]);
  const rotate2 = useTransform(scrollYProgress, [0, 1], [0, -260]);
  const scale2 = useTransform(scrollYProgress, [0, 1], [1.1, 1.25]);

  return (
    <>
      {/* Original blob */}
      <motion.div
        style={{
          position: "fixed",
          top: "10vh",
          right: "5vw",
          zIndex: -1,
          filter: "blur(0px)",
          x,
          y,
          rotate,
          scale,
        }}
        transition={{ type: "spring", stiffness: 60, damping: 20 }}
      >
        <svg
          width="480"
          height="480"
          viewBox="0 0 420 420"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <radialGradient id="blobGradient" cx="0%" cy="0%" r="100%">
              <stop offset="0%" stopColor="#FF9A9E" />
              <stop offset="35%" stopColor="#FECFEF" />
              <stop offset="70%" stopColor="#FAD0C4" />
              <stop offset="100%" stopColor="#FECFEF" stopOpacity="0.4" />
            </radialGradient>
          </defs>
          <motion.path
            d="M312.4 78.5C341 111.1 354.7 152.8 349.4 193.9C344.2 235 320.1 275.5 288.4 304.9C256.6 334.3 217.1 352.7 178.2 350.7C139.4 348.7 101.2 326.3 79.3 293.5C57.4 260.6 51.9 217.4 59.4 177.7C66.9 138.1 87.3 102 116.8 77.9C146.3 53.8 184.9 41.7 221.8 45.1C258.7 48.4 283.8 46 312.4 78.5Z"
            fill="url(#blobGradient)"
            initial={{ filter: "blur(40px)" }}
            animate={{ filter: "blur(30px)" }}
            transition={{
              repeat: Infinity,
              repeatType: "reverse",
              duration: 8,
              ease: "easeInOut",
            }}
          />
        </svg>
      </motion.div>

      {/* New, larger blob */}
      <motion.div
        style={{
          position: "fixed",
          left: 0,
          zIndex: -2,
          filter: "blur(0px)",
          x: x2,
          y: y2,
          rotate: rotate2,
          scale: scale2,
        }}
        transition={{ type: "spring", stiffness: 55, damping: 22 }}
      >
        <svg
          width="525"
          height="525"
          viewBox="0 0 525 525"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <radialGradient id="blobGradient2" cx="0%" cy="0%" r="100%">
              {/* warm pink / peachy center */}
              <stop offset="0%" stopColor="#FFC0CB" />
              <stop offset="30%" stopColor="#FFD1B3" />
              {/* soft pink halo */}
              <stop offset="65%" stopColor="#FFE4F2" />
              {/* very subtle lavender edge */}
              <stop offset="90%" stopColor="#E4D7FF" stopOpacity="0.45" />
              <stop offset="100%" stopColor="#F8F1FF" stopOpacity="0.25" />
            </radialGradient>
          </defs>
          <motion.path
            d="M390.5 102.3C426.2 143.9 443.2 197.6 436.3 248.9C429.4 300.2 398.7 349.1 359.2 383.9C319.7 418.7 271.5 439.4 223.8 436.9C176.1 434.3 129 408.5 101 371.4C73 334.3 64 285.8 73.4 240.4C82.8 195 110.6 152.7 148.4 122.5C186.2 92.3 234 74.3 280 78.7C326 83.1 354.8 60.7 390.5 102.3Z"
            fill="url(#blobGradient2)"
            initial={{ filter: "blur(45px)" }}
            animate={{ filter: "blur(35px)" }}
            transition={{
              repeat: Infinity,
              repeatType: "reverse",
              duration: 10,
              ease: "easeInOut",
            }}
          />
        </svg>
      </motion.div>
    </>
  );
}
